// Vuetify
import '@mdi/font/css/materialdesignicons.css'; // Ensure you are using css-loader
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as allDirectives from 'vuetify/directives';

// floating-vue owns v-tooltip app-wide; Vuetify's Tooltip directive would
// shadow it and stringify object configs into "[object Object]"
const directives = Object.fromEntries(
    Object.entries(allDirectives).filter(([name]) => name !== 'Tooltip')
);

import tirevault from './themes/tirevault';
import 'vuetify/styles';

import { fa } from 'vuetify/iconsets/fa';
import { mdi } from 'vuetify/iconsets/mdi';

export const vuetify = createVuetify({
    components,
    directives,
    styles: {
        configFile: 'src/css/settings.scss',
    },
    display: {
        mobileBreakpoint: 'sm',
        //Match TailwindCSS
        thresholds: {
            xs: 0,
            sm: 640,
            md: 768,
            lg: 1024,
            xl: 1280,
            '2xl': 1536
        },
    },
    icons: {
        defaultSet: 'mdi', // 'mdiSvg' || 'faSvg'
        sets: {
            fa,
            mdi,
        }
    },
    theme: {
        defaultTheme: 'tirevault',
        themes: {
            tirevault,
        },
    },
    defaults: {
        VAutocomplete: {
            color: 'primary',
            variant: 'outlined',
            density: 'comfortable',
            rounded: 'lg',
        },
        VCheckbox: {
            color: 'primary',
        },
        VDatePicker: {
            color: 'accent',
        },
        VFileInput: {
            color: 'primary',
            variant: 'outlined',
            density: 'comfortable',
            rounded: 'lg',
        },
        VRadio: {
            color: 'primary',
        },
        VSwitch: {
            color: 'primary',
        },
        VTextarea: {
            color: 'primary',
            variant: 'outlined',
            density: 'comfortable',
            rounded: 'lg',
        },
        VTextField: {
            color: 'primary',
            variant: 'outlined',
            density: 'comfortable',
            rounded: 'lg',
        },
        VSelect: {
            color: 'primary',
            variant: 'outlined',
            density: 'comfortable',
            rounded: 'lg',
        },
        VBtn: {
            color: 'primary',
            rounded: 'lg',
            elevation: 0,
        },
        VCard: {
            rounded: 'xl',
            elevation: 0,
            border: true,
        },
    },
});
